import React, { useState } from "react";
import Todolist from "./Todolist";

const Todo = () => {
    const [inputList, setInputList] = useState('');
    const [Items,setItems] = useState([]);
    const itemEvent = (event) => {
        setInputList(event.target.value);
    }
    const listofItems = () => {
         setItems((oldItems) =>{
             return [...oldItems, inputList];
         })
         setInputList('');
    }
    const deleteItems = (id) =>{
         //console.log("deleted");
         setItems((oldItems) =>{
            return oldItems.filter((ArrElem, index)=>{
               return index !==id;
            })
        })
    }

    return (
        <>
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <h2 className="text-center">TODO LIST</h2>
                    <div className="row g-3">
                        <div className="col-auto">
                            <input type="text" className="form-control" value={inputList} placeholder="Add a item" onChange={itemEvent} />
                        </div>

                        <div className="col-auto">
                            <button onClick={listofItems} className="btn btn-primary mb-3">+</button>
                        </div>
                    </div>
                    <hr />
                    <ol>
                        {/* <li>{inputList}</li> */}
                        {Items.map( (itemval, index) => {
                            return < Todolist 
                            key={index}
                            id={index} 
                            text = {itemval}
                            onSelect = {deleteItems}
                            />
                        })}
                    </ol>
                </div>
            </div>
        </>
    )
}

export default Todo;